import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const ValueAdd = () => {
  const theme = useTheme();

  const items = [
    {
      title: 'Ingeniería de Difusión',
      text: 'Como plataforma dirigida por ingenieros, garantizamos una arquitectura de software robusta, con transmisión on-demand y streaming de latencia mínima.',
    },
    {
      title: 'Medio Innovador',
      text: 'Somos un Media Lab que rompe con los esquemas tradicionales. No solo emitimos anuncios; creamos ecosistemas digitales donde la tecnología (CMS, CRM y estadísticas en tiempo real) asegura que su marca llegue al target correcto con precisión técnica.',
    },
    {
      title: 'Autoridad y Rigor',
      text: 'Al asociarse con nuestro contenido, su marca adquiere el prestigio de un medio que combina la experiencia de grandes figuras de la comunicación con la vanguardia tecnológica.',
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Ventajas
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          ¿Por qué Lácteos Barinas con TNO?
        </Box>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="h6" gutterBottom fontWeight={700}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ValueAdd;
